import { AltText, Icons } from '../../services/shared/shared-enums';
import { VerifyRoleLabels, VertexAPIAddressValidationFailedLabels, VertexAPIValidationLabels } from '../../services/shared/shared-interface';
import { AccountType, AdditionalLocations, RegistrationFormError } from './definitions';

export class RegistrationMappingFactory
{
	public static mapAdditionalLocationLabels(): AdditionalLocations
	{
		return  {
			locationPageDescription: {
				description1: 'In order to request your ',
				description2: ', you may select additional locations below, upload a list, or submit with your primary location.',
				tokenData: [
					{
						isLink: 'false',
						name: '$token1',
						text: 'Business Account',
						url: ''
					}
				]
			},
			heading1: 'Select Additional Locations',
			headingOr: 'or',
			heading2: {
				label: 'Upload List of Locations',
				iconPath: Icons.uploadLocationList,
				altText: AltText.uploadFile
			},
			logo: {
				iconPath: '',
				altText: 'Step 6'
			},
			stepNumber: '6',
			primaryLocationHeading: 'Primary Location',
			selectLocationTableHeader: {
				companyName: 'Company Name',
				address: 'Address',
				country: 'Country',
				selectAll: 'Select All'
			},
			uploadSuccessText: 'Your file is successfully uploaded.',
			uploadSuccessSubtext: 'Please click submit to complete your registration.'
		};
	}

	public static mapAccountTypeLabels(): AccountType
	{
		return {
			description: '',
			heading: 'Account Type',
			logo: {
				iconPath: '',
				altText: 'Step 4'
			},
			stepNumber: '4',
			individualAccount: {
				label: 'Submit as',
				description1: 'Manage your fleet and location(s) with the Individual Account.',
				description2: 'Please note, this type of Account cannot have multiple users.',
				tokenData: [
					{
						isLink: 'false',
						name: '$token1',
						text: 'Individual Account',
						url: ''
					}
				]
			},
			businessAccount: {
				label: 'Request',
				description1: 'Manage multiple locations and users with the MyToyota Enterprise Account!',
				description2: '',
				tokenData: [
					{
						isLink: 'false',
						name: '$token1',
						text: 'Enterprise Account',
						url: ''
					}
				]
			}
		};
	}
	public static mapFieldErrorText(): RegistrationFormError
	{
		return {
			requiredErrorMessage: '$token is a required field.',
			requiredDropdownErrorMessage: '$token must have value.',
			phoneSameNumber: 'Every number cannot be the same.',
			phoneLength: 'Phone number should have 10 numeric characters.',
			phoneSequenceNumber: 'Number cannot be sequential.',
			invalidCharacterWithNumericErrorMessage: 'Please enter a valid character.',
			minLengthZipCodeError: 'Postal Code should have 5 numeric characters.',
			canadaPostalCodeFormatError: 'Postal Code format is incorrect. Please enter the correct Postal Code.'
		};
	}
	public static mapVertexLabels(): VertexAPIValidationLabels
	{
		return {
			heading: 'Verify your address',
			description: 'We are not able to verify your address but found a close match',
			useVerifiedLabel: 'Use as Suggested',
			editAddressLabel: 'Use as Entered'
		};
	}
	public static mapVertexAddressFailedLabels(): VertexAPIAddressValidationFailedLabels
	{
		return {
			heading: 'Verify your address',
			description: 'We are not able to verify your address. Would you like to close and edit the details or proceed with what you have entered?',
			editAddressLabel: 'Entered Details'
		};
	}
	public static mapVerifyRoleLabels(): VerifyRoleLabels
	{
		return {
			description: 'No enterprise account was found for the company details you entered. Only Company Admins can create a new enterprise account. Please click “Confirm” to update your role to Company Admin.',
			dropdownLabel: 'Suggested Role',
			note: 'Requested role is subject to admin approval.'

		};
	}
}
